module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Report.d9f34097.svg";